
  const button = document.getElementById("glowbot-button");
  const chat = document.getElementById("glowbot-chat");
  const send = document.getElementById("glowbot-send");
  const input = document.getElementById("glowbot-input");
  const messages = document.getElementById("glowbot-messages");
  const closeButton = document.getElementById("glowbot-close");

 
 
 
  input.addEventListener("keypress", function(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    send.click();
  }
});


  button.addEventListener("click", () => {
    chat.style.display =
      chat.style.display === "flex" ? "none" : "flex";
  });

  closeButton.addEventListener("click", () => {
  chat.style.display = "none";
});

  function addMessage(sender, text) {
    const div = document.createElement("div");
    div.innerHTML = `<strong>${sender}:</strong> ${text}`;
    div.style.marginBottom = "10px";
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }


  document.addEventListener("DOMContentLoaded", () => {

    function randomResponse(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function getResponse(message) {

  message = message.toLowerCase();

  // Friends

  if (
    message.includes("richard") ||
    message.includes("rich racks") ||
    message === "rich"
  ) {
    return "Waddup Rich Racks?!";
  }

  if (
    message.includes("adesh") ||
    message.includes("cheeze") ||
    message.includes("addy")
  ) {
    return "Waddup Cheeze?!";
  }

  // Greetings

if (
  message.includes("hi") ||
  message.includes("hello") ||
  message.includes("hey") ||
  message.includes("hola")
) {
  return randomResponse([
    "Hi! 👋 I'm Glow Bot, your Glow Up Wireless assistant. How can I help you today?",
    "Hey there! Welcome to Glow Up Wireless.",
    "Howdy! 🤠 What can I help you with today?",
    "Hello! Thanks for visiting Glow Up Wireless.",
    "Hi! Need help with our plan, eSIM, or bringing your number over?"
  ]);
}

  // Plan

  if (
    message.includes("plan") ||
    message.includes("price") ||
    message.includes("cost") ||
    message.includes("how much")
  ) {
    return "Glow Up Wireless offers one simple plan: $30/month with unlimited talk, text, and data.";
  }

  // eSIM

  if (
    message.includes("esim") ||
    message.includes("e-sim")
  ) {
    return "Yes! Glow Up Wireless supports eSIM-compatible devices.";
  }

  // Physical SIM

  if (
    message.includes("sim card") ||
    message.includes("physical sim")
  ) {
    return "Yes! Physical SIM cards are available.";
  }

  // Porting

  if (
    message.includes("port") ||
    message.includes("bring my number") ||
    message.includes("keep my number") ||
    message.includes("transfer my number")
  ) {
    return "Absolutely! You can bring your current number to Glow Up Wireless. You'll need your account number and transfer PIN from your current carrier.";
  }

  // Activation

  if (
    message.includes("activate") ||
    message.includes("activation")
  ) {
    return "To activate service, simply follow the instructions included with your SIM card or eSIM setup.";
  }

  // Coverage

  if (
    message.includes("coverage") ||
    message.includes("network") ||
    message.includes("signal")
  ) {
    return "Glow Up Wireless operates on a nationwide network with coverage across most areas of the United States.";
  }

  // Compatibility

  if (
    message.includes("compatible") ||
    message.includes("phone work") ||
    message.includes("unlocked phone")
  ) {
    return "Most unlocked phones are compatible with Glow Up Wireless.";
  }

  // Hotspot

  if (
    message.includes("hotspot") ||
    message.includes("mobile hotspot")
  ) {
    return "Hotspot is not currently available.";
  }

  // Support

  if (
    message.includes("support") ||
    message.includes("help") ||
    message.includes("agent") ||
    message.includes("representative")
  ) {
    return "For additional assistance, please contact our support team at rahhtechsolutions@gmail.com.";
  }

  // How are you

if (
  message.includes("how are you") ||
  message.includes("how's it going")
) {
  return "I'm doing great! Thanks for asking. 😊 How can I help you with Glow Up Wireless today?";
}

// What's up

if (
  message.includes("whats up") ||
  message.includes("what's up") ||
  message.includes("sup")
) {
  return "Not much! Just helping customers stay connected. 📱 What can I help you with today?";
}

// Good morning

if (
  message.includes("good morning")
) {
  return "Good morning! ☀️ Welcome to Glow Up Wireless. How can I help?";
}

// Good afternoon

if (
  message.includes("good afternoon")
) {
  return "Good afternoon! 👋 How can I assist you today?";
}

// Good evening

if (
  message.includes("good evening")
) {
  return "Good evening! 🌙 Thanks for visiting Glow Up Wireless. How can I help?";
}

// Who are you

if (
  message.includes("who are you")
) {
  return "I'm Glow Bot, the Glow Up Wireless virtual assistant. I'm here to answer questions about our service, plans, activations, and more.";
}

// Are you real

if (
  message.includes("are you real") ||
  message.includes("are you a robot")
) {
  return "I'm Glow Bot, a virtual assistant. While I'm not a human, I'm here to help answer your Glow Up Wireless questions.";
}

// Tell me a joke

if (
  message.includes("joke") ||
  message.includes("tell me something funny")
) {
  return randomResponse ([ 
    "Why don't cell phones ever get lost? Because they always have good reception. 😄",
    "When does a joke become a dad joke? A: When it becomes apparent.",
    "I'm reading a book about anti-gravity. It's impossible to put down!",
    "I used to play soccer for the sport, but now I'm just doing it for kicks.",
    "Why did the smartphone wear glasses? Because it lost all its contacts!",
    "Why did the cell phone get arrested? It was charged with battery!",
    "What kind of phone do prisoners use to talk to each other? Cell phones!",
    "How did the smartphone propose to its girlfriend? It gave her a ring! "

   ]); 
}

// Nice

if (
  message.includes("nice") ||
  message.includes("cool")
) {
  return "Glad you think so! 😎";
}

// Bye

if (
  message.includes("bye") ||
  message.includes("goodbye")
) {
  return "Thanks for visiting Glow Up Wireless! Have a great day. 👋";
}

// I love you

if (
  message.includes("i love you")
) {
  return "That's very kind of you! 💚 I'm always happy to help.";
}

// You're awesome

if (
  message.includes("you're awesome") ||
  message.includes("your awesome") ||
  message.includes("you are awesome")
) {
  return "Thank you! 😊 I'll do my best to keep being helpful.";
}

  // Thanks

  if (
    message.includes("thanks") ||
    message.includes("thank you")
  ) {
    return "You're welcome! 😊 Let me know if there's anything else I can help with.";
  }

  return "I couldn't find an answer for that. Please contact support at rahhtechsolutions@gmail.com.";
}


  send.addEventListener("click", () => {

    const text = input.value.trim();

    if (!text) return;

    addMessage("You", text);

    const response = getResponse(text);

    setTimeout(() => {
      addMessage("Glow Bot", response);
    }, 300);

    input.value = "";
  });

  addMessage(
    "Glow Bot",
    "👋 Welcome to Glow Up Wireless! Ask me about plans, eSIM, activations, number transfers, or support."
  );
});